
<template>
  <Card class="box" title="档案详情">
    <Spin fix v-if="showPageLoading"></Spin>
    <div style="padding: 10px;">
      <div style=" display: flex;">
        <Alert class="archive" style="width: 180px;height: 33px;margin-right: 5px;" :type="data.isArchiveInTalentCenter===true?'success':data.isArchiveInTalentCenter===false?'warning':'error'">
          <h3 :style="data.isArchiveInTalentCenter===true?'color:#19be6b;':data.isArchiveInTalentCenter===false?'color:#ff9900;':'color:#ed4014;'">
            {{data.isArchiveInTalentCenter===true?'档案在人才中心':data.isArchiveInTalentCenter===false?'档案不在人才中心':'档案检测异常'}}</h3>
        </Alert>

        <Button v-if="data.isArchiveInTalentCenter===null" type="warning" icon="md-repeat" style="margin-right:10px;" @click="retestArchive" :loading="retestArchiveLoading">重新检测</Button>
      </div>
      <table class="table_flower">
        <tr>
          <th style="width: 40%;">落户类型</th>
          <td style="width: 60%;">{{ data.applicationTypeText }}</td>
        </tr>
        <tr>
          <th>办文单号</th>
          <td>{{ data.documentNumber }}</td>
        </tr>
        <tr>
          <th>申请人姓名</th>
          <td>{{ data.serverData.person.f_name }}</td>
        </tr>
        <tr>
          <th>申请人身份证号</th>
          <td>{{ data.identityNumber }}</td>
        </tr>
        <tr>
          <th>单位名称</th>
          <td>{{ data.serverData.unitInfo.f_unitname }}</td>
        </tr>
        <tr>
          <th>统一社会信用代码（或组织机构代码）</th>
          <td>{{ data.serverData.unitInfo.f_unitcode }}</td>
        </tr>
      </table>

      <div v-for="(archives, index) in data.lhApplicationFileVerificationList" :key="index">
        <Divider style="margin-top:40px;" orientation="left">
          核档信息
        </Divider>
        <div style="margin-top: 5px;">
          <Alert v-if="archives.filesVerificationRemark" type="warning">核档备注：{{ archives.filesVerificationRemark}}</Alert>
        </div>
        <template v-if="archives.fileVerificationInfoType===$store.state.fileVerificationInfoType.落户档案在单位">
          <Alert class="archive" style="width: 130px;height: 33px;margin-right: 5px;" :type="'warning'" v-if="archives.lhFileVerificationGuidListPreview.length==0">
            <h3 style="color:#ff9900;">
              暂无核档信息
            </h3>
          </Alert>
          <table class="table_flower">
            <tr>
              <th>当前状态</th>
              <td>
                <span>{{
                      archives.filesVerificationStatusText
                    }}</span>
              </td>
            </tr>
          </table>
          <div style="margin-top:10px;">
            <div class="_link" v-for="(file,index_) in archives.lhFileVerificationGuidListPreview" :key="index_" @click="handlePreview2(file)">
              <Icon :type="file.name | fileType" />
              {{file.name}}
              <!-- <Icon type="md-download" @click.stop="handelFileDownload(file.guid,file.name)" /> -->
            </div>
          </div>
        </template>
        <template v-else-if="archives.fileVerificationInfoType===$store.state.fileVerificationInfoType.档案在人才中心">
          <Alert class="archive" style="width: 130px;height: 33px;margin-right: 5px;" :type="'warning'" v-if="archives.fileVerificationResultInfo.length==0">
            <h3 style="color:#ff9900;">
              暂无核档信息
            </h3>
          </Alert>
          <table class="table_flower">
            <tr>
              <th>当前状态</th>
              <td>
                <span>{{
                      archives.filesVerificationStatusText
                    }}</span>
              </td>
            </tr>
          </table>
          <div style="margin-top:10px;" v-for="(fileVerification,index_) in archives.fileVerificationResultInfo" :key="index_">

            <table class="table_flower">
              <tr>
                <th style="width: 40%;">姓名</th>
                <td style="width: 60%;">
                  {{ archives.name }}
                </td>

              </tr>
              <tr>

                <th>身份证号</th>
                <td>
                  {{ archives.idNo }}
                </td>
              </tr>
              <tr>
                <th>档案材料</th>
                <td>
                  <Tooltip content="点击打开档案材料" placement="top" transfer>
                    <a :href="'http://inner.pdrcfw.cn/ArchivesMgmt/ArchivesViewPDF.aspx?PersonnelID=' + fileVerification.personnelID" target="_blank" rel="noopener noreferrer">{{ fileVerification.personnelID
                        }}</a>
                  </Tooltip>
                </td>
              </tr>
              <tr>

                <th>新系统办文单号</th>
                <td>
                  {{ archives.documentNumber }}
                </td>
              </tr>
              <tr>
                <th>来沪前最后工作单位</th>
                <td>
                  {{ fileVerification.lastCompany }}
                </td>
              </tr>
              <tr>
                <th>来沪前最后工作单位离职时间</th>
                <td>
                  {{ fileVerification.quitDate }}
                </td>
              </tr>
              <tr>
                <th>来沪前最后机关、事业单位</th>
                <td>
                  {{ fileVerification.lastGovCompany }}
                </td>
              </tr>
              <tr>
                <th>来沪前最后机关、事业单位离职时间</th>
                <td>
                  {{ fileVerification.govquitDate }}
                </td>
              </tr>
              <tr>
                <th>配偶姓名</th>
                <td>
                  {{ fileVerification.spouseName }}
                </td>
              </tr>
              <tr>
                <th>子女姓名</th>
                <td>
                  {{ fileVerification.childrenName }}
                </td>
              </tr>

              <tr>
                <th>离职原因</th>
                <td>
                  {{fileVerification.quitReason }}
                </td>
              </tr>
              <tr>
                <th>中级职称 评/考/聘所在单位</th>
                <td>
                  {{ fileVerification.zcMiddleCo }}
                </td>
              </tr>
              <tr>
                <th>高级职称 评/考/聘所在单位</th>
                <td>
                  {{ fileVerification.zcSeniorCo }}
                </td>
              </tr>
              <tr>
                <th>本人经历Experience</th>
                <td>
                  {{ fileVerification.experience }}
                </td>
              </tr>
              <tr>
                <th>有无不良行为记录</th>
                <td>
                  {{ fileVerification.behavior | isValue }}
                </td>
              </tr>
              <tr>
                <th>奖惩记录</th>
                <td>
                  {{ fileVerification.rewards }}
                </td>
              </tr>
              <tr>
                <th>不良行为记录详细说明</th>
                <td>
                  {{ fileVerification.behaviordetail }}
                </td>
              </tr>
              <tr>
                <th>备注</th>
                <td col>
                  {{ fileVerification.inRemark }}
                </td>
              </tr>
              <tr>
                <th>摘录时间 </th>
                <td>
                  {{ fileVerification.completeTime }}
                </td>
              </tr>
              <tr>
                <th>发起时间</th>
                <td>
                  <span class="cont">{{ archives.creationTimeText }}</span>
                </td>
              </tr>

            </table>
          </div>
        </template>
      </div>

    </div>
  </Card>
</template>
<script>
import '../residencePermitIntegral/styles/points.less'

export default {
  data() {
    return {
      data: {
        serverData: {
          person: {
            prclhPersonExt: {},
          },
          unitInfo: {},
        },
        lhApplicationFileVerificationList: [],
      },
      m: '',
      guid: '',
      toLinkType: '',
      showPageLoading: false,
      columnsApprove: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 80,
        },
        {
          title: '节点',
          key: 'f_stepstart',
          align: 'center',
          width: 120,
        },
        {
          title: '办理人员',
          key: 'f_username',
          align: 'center',
          width: 120,
        },
        {
          title: '时间',
          key: 'f_approvedate',
          align: 'center',
          width: 180,
        },
        {
          title: '结果',
          key: 'f_approveresult',
          align: 'center',
          width: 120,
        },
        {
          title: '下一节点',
          key: 'f_stepend',
          align: 'center',
          width: 120,
        },
        {
          title: '备注',
          key: 'f_remark',
          align: 'center',
        },
      ],
    }
  },
  created() {
    // this.data = this.$route.query.data
    this.m = this.$route.query.m
    console.log('🚀 ~ created ~ this.m:', this.m)
    // decodeURIComponent()
    this.guid = this.$route.query.guid
    this.toLinkType = this.$route.query.type
    this.getInit()
  },
  methods: {
    // 获取详情
    async getInit() {
      this.showPageLoading = true
      try {
        if (this.guid) {
          let { data } = await this.$Ajax.get('/api/services/app/JZZJF/GetFileVerificationInfo', {
            params: { guid: this.guid, m: this.m },
          })

          data.result.serverData = data.result.lhApplicationJsonData.resultData
          this.data = data.result
        } else {
          this.$Message.error('未获取到数据')
          this.$router.back()
        }
      } catch (error) {
        this.$Modal.error({
          title: '错误',
          content: '未能正常打开',
        })
      }

      this.showPageLoading = false
    },
  },
}
</script>
<style lang="less" scoped>
.box {
  max-height: 100vh;
  overflow: auto;
}
/deep/.ivu-card-body {
  min-height: 100vh;
}
/deep/.archive.ivu-alert {
  padding: 8px 8px 8px 15px;
}
</style>
